export const COLORS_PALETTE_1 = ['#00b652', '#0075c6', '#003f5c', '#bd2dbd'];
export const COLORS_PALETTE_2 = ['#94d752', '#00b652', '#00b6ef', '#0075c6', '#022ca1', '#003f5c', '#73359c', '#bd2dbd', '#94d75280', '#00b65280', '#ff17c9'];